import Action from '../../Action'
import './styles/ModalCreateException.css'
import { useState ,useEffect} from 'react';
import LoadSimple from '../../LoadSimple';
import { useFetch } from '../../../hooks/useFetch';
import SelectorAdmin from '../../SelectorAdmin';
import SelectorIcons from '../../SelectorIcons';
import { capitalizeFirstLetter } from '../../../utils/utils';
import { lang } from '../../generales/traduction';
const ModalAddDelay =({
      server,
      languaje,
      mode,
      setDataWorkFlow,
      dataWorkFlow,
      closeModal,
      SetElementList,
      elementsList,
      handleRemoveItem
})=>{
   

    const [disabled,setDisabled]=useState(true)
   
useEffect(()=>{
    setDataWorkFlow((prevState)=>{
        return {
            ...prevState,
          ['action_retry_times']:1
        }
        
    })
},[])
        const reqField=()=>{
            return(
              <p className='reqField-gs'>
                *
              </p>
            )
          }



    // const metricData=useFetch('cassia/workflow_events/by_trigger/'+dataWorkFlow.trigger_id,'','','GET',server)
    // const metricData=useFetch('cassia/brands','','','GET',server)

    const url=(dataWorkFlow.hostid==null)?'cassia/workflow_actions/actions_by_group/'+dataWorkFlow.groupid:'cassia/workflow_actions/actions_by_host/'+dataWorkFlow.hostid
    const metricData=useFetch(url,'','','GET',server)

    const changeOption=(option,index)=>{
        let attr=''
        if(option.filter=='Marcas'){
            attr='brand_id'
        }else if(option.filter=='hostModel'){
            attr='model_id'
        }
        else if(option.filter=='period'){
            attr='agent_type_id'
        }
        else if(option.filter=='trigger'){
            attr='value_type_id'
        }

        // setManttoData((prevState)=>{
        //     return {
        //         ...prevState,
        //         [attr]:option.value===""?0:(parseInt(option.value))
        //     }

        // })
        // setManttoRelation(option.value)
        setDataWorkFlow((prevState)=>{
          return {
              ...prevState,
            ['action_retry_times']:option.value===""?1:(parseInt(option.value))
          }
          
      })
        SetElementList((prevState)=>{
          return {
              ...prevState,
            ['delay']:option.label
          }
          
      })
    }
   
    const cancelItem=()=>{
      setDataWorkFlow((prevState)=>{
        return {
            ...prevState,
          ['action_retry_times']:1
        }
        
    })
    SetElementList((prevState)=>{
      return {
          ...prevState,
        ['delay']:""
      }
      
  })
  handleRemoveItem({ id: 'delay', label: capitalizeFirstLetter(lang[languaje]['aplazar']), type: 'delay' })
  closeModal()
    }
     
    // const handleChange=(e)=>{
    //     console.log(e.target.name)
    //     const {name,value}=e.target
        
    //         setDataWorkFlow((prevState)=>{
    //             return {
    //                 ...prevState,
    //                 [name]:value
    //             }
                
    //         })
    //         SetElementList((prevState)=>{
    //             return {
    //                 ...prevState,
    //               ['delay']:value+" hrs."
    //             }
                
    //         })
    //   }
    const handleTimeChange = (event) => {
      let input = event.target.value;
      
          const {name,value}=event.target
      // Remueve cualquier carácter no numérico excepto el `:`
      // input = input.replace(/[^0-9:]/g, "");
  
      // // Inserta `:` en la posición correcta si falta
      // if (input.length >= 3 && input[2] !== ":") {
      //   input = `${input.slice(0, 2)}:${input.slice(2, 4)}`;
      // }
  
      // // Limita el valor al formato `HH:MM`
      // if (input.length > 5) {
      //   input = input.slice(0, 5);
      // }
      
      // // Asegura que solo horas entre 00 y 23 y minutos entre 00 y 59 sean válidos
      // const [hours, minutes] = input.split(":");
      // if (hours && (parseInt(hours, 10) > 23)) return;
      // if (minutes && (parseInt(minutes, 10) > 59)) return;
  
      setDataWorkFlow((prevState)=>{
                    return {
                        ...prevState,
                        [name]:input
                    }
                    
                })
                SetElementList((prevState)=>{
                              return {
                                  ...prevState,
                                ['delay']:input+""
                              }
                              
                          })
    };
    const handleKeyDown = (event) => {
      const {name,value}=event.target
      const [hoursStr, minutesStr] = dataWorkFlow.action_retry_times.split(":");
      let hours = parseInt(hoursStr, 10);
      let minutes = parseInt(minutesStr, 10);
  
      // Sumar o restar horas/minutos según la flecha presionada
      if (event.key === "ArrowUp") {
        if (event.target.selectionStart <= 2) {
          hours = (hours + 1) % 24;
        } else {
          minutes = (minutes + 1) % 60;
        }
      } else if (event.key === "ArrowDown") {
        if (event.target.selectionStart <= 2) {
          hours = (hours - 1 + 24) % 24;
        } else {
          minutes = (minutes - 1 + 60) % 60;
        }
      } else {
        return;
      }
  
      // Actualiza el valor formateado `HH:MM`
      const updatedTime = `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}`;
      setDataWorkFlow((prevState)=>{
        return {
            ...prevState,
            [name]:updatedTime
        }
        
    })
    SetElementList((prevState)=>{
                  return {
                      ...prevState,
                    ['delay']:updatedTime+" hrs."
                  }
                  
              })
      event.preventDefault(); // Previene el comportamiento por defecto de las flechas
    };
  
    function validateTimeFormat(time) {
      const timeRegex = /^(?:[01]\d|2[0-3]):[0-5]\d$/;
      // console.log(timeRegex.test(time))
      return timeRegex.test(time);
    }
      const handleKeyPress = (e) => {
        // Permitir solo números, teclas de control y el punto decimal
        const charCode = e.charCode;
        if (
          (charCode >= 48 && charCode <= 57) || // Números 0-9
          charCode === 46 || // Punto decimal
          charCode === 8 || // Retroceso
          charCode === 37 || // Flecha izquierda
          charCode === 39 // Flecha derecha
        ) {
          return;
        } else {
          e.preventDefault();
        }
      };
    
      const handlePaste = (e) => {
        const paste = (e.clipboardData || window.clipboardData).getData('text');
        if (!/^-?\d*\.?\d*$/.test(paste)) {
          e.preventDefault();
        }
      };
      const dta_dumy=[
        {"id": 1, "name": "per day"},
        {"id": 2, "name": "per week "},
        {"id": 3, "name": "per month "},


    ]
    const {action_retry_times}=dataWorkFlow;
    return(
        <div className="modal-GS-content">
            <div className='card-modal-gs modal-verificate'>
                <div className='head-card-modal-gs'>
                    <div className='title-head-card-modal-gs'>
                        {(lang[languaje]['agregar'].toUpperCase())+' NUMERO DE INTENOS'}
                    </div>
                </div>
                <div className='content-card-modal-gs' style={{overflowY: 'scroll',scrollbarWidth: 'thin'}}>
                
                                    <div className="form-GS-box"> 
                                    {/* <div className="user-box-GS "  style={{height:'30%'}}>
                                        {
                                            (metricData.loading)?<p style={{color:'var(--txt-color)'}}> {capitalizeFirstLetter(lang[languaje]['CargandoDatos'])} . . .</p>:
                                            <SelectorAdmin placeholder={'Seleccionar nivel...'} opGeneral={true} txtOpGen={''}  opt_de={(metricData==null)?0:metricData} origen={'Admin'} data={dta_dumy}   loading={metricData.loading}  titulo='Estados' selectFunction={changeOption} index={0}></SelectorAdmin>
                                            // <SelectorAdmin placeholder={'Seleccionar nivel...'} opGeneral={true} txtOpGen={''}  opt_de={(metricData==null)?0:metricData} origen={'Admin'} data={metricData.data.data}   loading={metricData.loading}  titulo='Estados' selectFunction={changeOption} index={0}></SelectorAdmin>
                                        }
                                        <label className='label-GS' style={{top:'2% '}}>{'lapso'}</label>   
                                    </div> */}
                                    <div className="user-box-GS"  style={{height:'20%'}}>
                                    {/* <input required name="action_retry_times"   min="0"  type="number" value={action_retry_times}
                                    onChange={handleChange} onKeyPress={handleKeyPress} 
                                    onPaste={handlePaste}  /> */}
                                     <input required name="action_retry_times"   type="number" value={action_retry_times}
                                    onChange={handleTimeChange } min={1}
                                    maxLength="5"
                                    placeholder=""  />
                                        <label className='label-GS  ' style={{top:'-25%'}}>{"Numero de intentos"}</label>
                                        
                                    </div>
                                    
                                
                                   
                                    
                                    
                                    <div className="user-box-GS" style={{height:'50%'}}>
                                        {
                                            
                                            <>
                                            <Action disabled={false} origen='Cancelar' titulo={capitalizeFirstLetter(lang[languaje]['cancelar'])}  action={cancelItem}/>
                                            <Action disabled={false} origen='Azul' titulo={capitalizeFirstLetter(lang[languaje]['guardar'])}  action={closeModal}/>
                                            </>
                                            // <Action disabled={disabled} origen='Login' titulo='Guardar'  action={Registrar}/>
                                        }
                                            
                                    {
                                        // (registerIsValid && data.message!=="User deleted successfully")?<span className='form-msg-ok'>Usuario registrado correctamente</span>:''
                                    }
                                        
                                    </div>
                                </div>
                </div>
                </div>
        </div>
    )
}

export default ModalAddDelay